import { Armchair16 } from '@cian/ui-kit/icons/16/armchair';
import { Bike16 } from '@cian/ui-kit/icons/16/bike';
import { Calendar16 } from '@cian/ui-kit/icons/16/calendar';
import { Cleaning16 } from '@cian/ui-kit/icons/16/cleaning';
import { Comments16 } from '@cian/ui-kit/icons/16/comments';
import { Document16 } from '@cian/ui-kit/icons/16/document';
import { Fitness16 } from '@cian/ui-kit/icons/16/fitness';
import { Flipchart16 } from '@cian/ui-kit/icons/16/flipchart';
import { Fridge16 } from '@cian/ui-kit/icons/16/fridge';
import { Fruit16 } from '@cian/ui-kit/icons/16/fruit';
import { Locker16 } from '@cian/ui-kit/icons/16/locker';
import { Office16 } from '@cian/ui-kit/icons/16/office';
import { Parking16 } from '@cian/ui-kit/icons/16/parking';
import { Phone16 } from '@cian/ui-kit/icons/16/phone';
import { Pin16 } from '@cian/ui-kit/icons/16/pin';
import { Planet16 } from '@cian/ui-kit/icons/16/planet';
import { Print16 } from '@cian/ui-kit/icons/16/print';
import { Reception16 } from '@cian/ui-kit/icons/16/reception';
import { Repair16 } from '@cian/ui-kit/icons/16/repair';
import { Restaurant16 } from '@cian/ui-kit/icons/16/restaurant';
import { Security16 } from '@cian/ui-kit/icons/16/security';
import { Tea16 } from '@cian/ui-kit/icons/16/tea';
import { Wifi16 } from '@cian/ui-kit/icons/16/wifi';
import * as React from 'react';

// Нет в UI-Kit'е
import { Support16 } from '../../icons/support';

export const coworkingAmenitiesIcons = {
  wifi: <Wifi16 />,
  bikeParking: <Bike16 />,
  internet: <Planet16 />,
  restZone: <Armchair16 />,
  cafe: <Restaurant16 />,
  cleaning: <Cleaning16 />,
  kitchen: <Fridge16 />,
  furniture: <Office16 />,
  security: <Security16 />,
  parking: <Parking16 />,
  meetingRoom: <Comments16 />,
  printer: <Print16 />,
  reception: <Reception16 />,
  modern: <Repair16 />,
  gym: <Fitness16 />,
  phoneBooth: <Phone16 />,
  techSupport: <Support16 />,
  events: <Calendar16 />,
  fax: <Document16 />,
  flipchart: <Flipchart16 />,
  fruits: <Fruit16 />,
  tea: <Tea16 />,
  lockers: <Locker16 />,
  legalAddress: <Pin16 />,
};
